// extracted by mini-css-extract-plugin
export default {"copy":"CopyButton_copy__OgMUM"};